export const USER_ROLE = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  AGENT: "Agent",
};
export const USER_TYPES = {
  ADMIN: "admin",
  AGENT: "agent",
};
export const DEFAULT_USER_TYPE = USER_TYPES.AGENT;
export const DATAGRID_DEFAULT_PAGE_SIZE = 50;
export const REWARD_INVENTORY_DEFAULT_PAGE_SIZE = 48;

